// Form validation for New credential form
import { plaintextValidator, dropdownValidator } from '../fields';

const config = { mandatory: true, customError: `^ Required` };
const dropdownConfig = { mandatory: true, customError: `Required` };

export default {
  name: plaintextValidator(config),
  // 'client.accountId': dropdownValidator(dropdownConfig),
  'site.id': dropdownValidator(dropdownConfig),
  'assetClass.classId': dropdownValidator(dropdownConfig)
};
